import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import axiosInstance from '../../utils/axiosSetup';
import usePermissionChecker from '../../action/checkPermission';

const TwoColumn = () => {
    const { checkPermission } = usePermissionChecker();
    const user = JSON.parse(localStorage.getItem('userInfo'));

    const [leavecount, setLeaveCount] = useState("");
    const location = useLocation();
    const [activeDropdown, setActiveDropdown] = useState(null);

    const fetchLeaves = async () => {
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/leaves/create`)
            .then(response => {
                setLeaveCount(response.data.data.count);
            })
            .catch(error => {
                console.error('Error', error);
                setLeaveCount("");
            });
    }
    useEffect(() => {
        fetchLeaves();
    }, []);

    const handleDropdownToggle = (dropdownName) => {
        setActiveDropdown(activeDropdown === dropdownName ? null : dropdownName);
    };

    const isActive = (path) => location.pathname === path ? 'active' : '';

    const subDropDown = {
        padding: '8px',
        lineHeight: 'normal',
        background: '#ebeaea',
        borderRadius: '6px',
    };
    const menuArrow = {
        fontSize: '12px', marginLeft: 'auto'
    }
    const a = {
        display: 'flex', alignItems: 'center'
    }

    return (
        <div className="two-col-bar" id="two-col-bar">
            <div className="sidebar sidebar-twocol" id="navbar-nav">
                <div className="sidebar-left slimscroll">
                    <div className="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                        <Link className="nav-link active" id="v-pills-dashboard-tab" title="Dashboard" data-bs-toggle="pill"
                            to="#v-pills-dashboard" role="tab" aria-controls="v-pills-dashboard" aria-selected="true">
                            <span className="material-icons-outlined">
                                home
                            </span>
                        </Link> 
                        <Link className="nav-link" id="v-pills-apps-tab" title="Master" data-bs-toggle="pill"
                            to="#v-pills-apps" role="tab" aria-controls="v-pills-apps" aria-selected="false">
                            <span className="material-icons-outlined">
                                dashboard
                            </span>
                        </Link> 

                        {(checkPermission("Client")) && (
                            <Link className="nav-link" id="v-pills-clients-tab" title="Clients" data-bs-toggle="pill"
                                to="#v-pills-clients" role="tab" aria-controls="v-pills-clients" aria-selected="false">
                                <span className="material-icons-outlined">
                                    group_add
                                </span>
                            </Link> 
                        )}

                        {((checkPermission("Projects")) || (checkPermission("Project Meter")) || (checkPermission("Assign Project"))) && (
                            <Link className="nav-link" id="v-pills-projects-tab" title="Projects" data-bs-toggle="pill"
                                to="#v-pills-projects" role="tab" aria-controls="v-pills-projects" aria-selected="false">
                                <span className="material-icons-outlined">
                                    request_quote
                                </span>
                            </Link> 
                        )}
                        <Link className="nav-link" id="v-pills-employees-tab" title="Employees" data-bs-toggle="pill"
                            to="#v-pills-employees" role="tab" aria-controls="v-pills-employees"
                            aria-selected="false">
                            <span className="material-icons-outlined">
                                people
                            </span>
                        </Link>                         
                        <Link className="nav-link" id="v-pills-timelog-tab" title="Timelog" data-bs-toggle="pill" to="#v-pills-timelog" role="tab" aria-controls="v-pills-timelog" aria-selected="false">
                            <span className="material-icons-outlined">
                                topic
                            </span>
                        </Link> 
                        {/* <Link className="nav-link" id="v-pills-tickets-tab" title="Tickets" data-bs-toggle="pill"
                            to="#v-pills-tickets" role="tab" aria-controls="v-pills-tickets" aria-selected="false">
                            <span className="material-icons-outlined">
                                confirmation_number
                            </span>
                        </Link>  */}

                        {(checkPermission("QA")) && (
                            <Link className="nav-link" id="v-pills-documentation-tab" title="QA" data-bs-toggle="pill" 
                                to="#v-pills-qa" role="tab" aria-controls="v-pills-qa" aria-selected="false">
                                <span className="material-icons-outlined">
                                    report_gmailerrorred
                                </span>
                            </Link> 
                        )}

                        {((checkPermission("Daily Reports")) || (checkPermission("Project Reports"))) && (
                            <Link className="nav-link" id="v-pills-daily-reports-tab" title="Reports" data-bs-toggle="pill" 
                                to="#v-pills-daily-reports" role="tab" aria-controls="v-pills-daily-reports" aria-selected="false">
                                <span className="material-icons-outlined">
                                    description
                                </span>
                            </Link> 
                        )}
                    </div>
                </div>
                <div className="sidebar-right">
                    <div className="tab-content" id="v-pills-tabContent">
                        <div className="tab-pane fade show active" id="v-pills-dashboard" role="tabpanel"
                            aria-labelledby="v-pills-dashboard-tab">
                            <p>Dashboard</p>
                            <ul>
                                <li><Link to="/dashboard" className={isActive('/dashboard')}>Dashboard</Link></li>
                            </ul>
                        </div>
                        <div className="tab-pane fade" id="v-pills-apps" role="tabpanel" aria-labelledby="v-pills-apps-tab">
                            <p>Master</p>
                            <ul>
                                {(checkPermission("Roles")) && (
                                    <li><Link to="/roles" className={isActive('/roles')}>Roles</Link></li>
                                )}
                                {(checkPermission("Permissions")) && (
                                    <li><Link to="/permissions" className={isActive('/permissions')}>Permissions</Link></li>
                                )}
                                {(checkPermission("Role Permission")) && (
                                    <li><Link to="/role-permission" className={isActive('/role-permission')}>Role Permission</Link></li>
                                )}
                                {(checkPermission("Departments")) && (
                                    <li><Link to="/departments" className={isActive('/departments')}>Departments</Link></li>
                                )}
                                {(checkPermission("Task Types")) && (
                                    <li><Link to="/task-types" className={isActive('/task-types')}>Task Types</Link></li>
                                )}
                                {(checkPermission("Leaves Credebility")) && (
                                    <li><Link to="/leaves-credebility" className={isActive('/leaves-credebility')}>Leaves Credebility</Link></li>
                                )}
                                {(checkPermission("Basic Projects")) && (
                                    <li><Link to="/basic-projects" className={isActive('/basic-projects')}>Basic Projects</Link></li>
                                )}
                                
                                {user.role_name === 'Super-Admin' ? (
                                    <li><Link to="/announcements" className={isActive('/announcements')}>Announcements</Link></li>
                                ) : (
                                    <li><Link to="/all-announcements" className={isActive('/announcements')}>Announcements</Link></li>
                                )}

                                {(checkPermission("Channel")) && (
                                    <li className="submenu">
                                        <Link to="#" onClick={() => handleDropdownToggle('channel')} 
                                                className={activeDropdown === 'channel' ? 'subdrop' : ''} style={{...a}}>
                                            <span>Channel</span> 
                                            <span className="menu-arrow" style={{...menuArrow}}></span>
                                        </Link> 
                                        <ul style={{...subDropDown, display: activeDropdown === 'channel' ? 'block' : 'none' }}>
                                            <li><Link to="/channels" className={isActive('/channels')}>Current Channel List</Link></li>
                                            <li><Link to="/inactive-channels" className={isActive('/inactive-channels')}>Past Channel List</Link></li>
                                        </ul>
                                    </li>
                                )}

                                {(checkPermission("Meter")) && (
                                    <li className="submenu">
                                        <Link to="#" onClick={() => handleDropdownToggle('meter')} 
                                                className={activeDropdown === 'meter' ? 'subdrop' : ''} style={{...a}}>
                                            <span>Meter</span> 
                                            <span className="menu-arrow" style={{...menuArrow}}></span>
                                        </Link> 
                                        <ul style={{...subDropDown, display: activeDropdown === 'meter' ? 'block' : 'none' }}>
                                            <li><Link to="/meter" className={isActive('/meter')}>Active Meter</Link></li>
                                            <li><Link to="/inactive-meter" className={isActive('/inactive-meter')}>Inactive Meter</Link></li>
                                        </ul>
                                    </li>
                                )}

                                <li><Link to="/calendar" className={isActive('/calendar')}>Calendar</Link></li>
                                <li><Link to="/holidays" className={isActive('/holidays')}>Holiday</Link></li>
                            </ul>
                        </div>

                        {(checkPermission("Client")) && (
                            <div className="tab-pane fade" id="v-pills-clients" role="tabpanel"
                                aria-labelledby="v-pills-clients-tab">
                                <p>Clients</p>
                                <ul>
                                    <li><Link to="/clients" className={isActive('/clients')}>Active Clients</Link></li>
                                    <li><Link to="/inactive-clients" className={isActive('/inactive-clients')}>Inactive Clients</Link></li>
                                </ul>
                            </div>
                        )}

                        {((checkPermission("Projects")) || (checkPermission("Project Meter")) || (checkPermission("Assign Project"))) && (
                            <div className="tab-pane fade" id="v-pills-projects" role="tabpanel"
                                aria-labelledby="v-pills-projects-tab">
                                <p>Projects</p>
                                <ul>
                                    {(checkPermission("Projects")) && (
                                        <li className="submenu">
                                            <Link to="#" onClick={() => handleDropdownToggle('project')} 
                                                    className={activeDropdown === 'project' ? 'subdrop' : ''} style={{...a}}>
                                                <span> Projects</span> 
                                                <span className="menu-arrow" style={{...menuArrow}}></span>
                                            </Link> 
                                            <ul style={{...subDropDown, display: activeDropdown === 'project' ? 'block' : 'none' }}>
                                                <li><Link to="/projects" className={isActive('/projects')}>Active</Link></li>
                                                <li><Link to="/on-hold-projects" className={isActive('/on-hold-projects')}>On Hold</Link></li>
                                                <li><Link to="/completed-projects" className={isActive('/completed-projects')}>Completed</Link></li>
                                                <li><Link to="/inactive-projects" className={isActive('/inactive-projects')}>Inactive</Link></li>
                                            </ul>
                                        </li>
                                    )}

                                    {(checkPermission("Project Meter")) && (
                                        <li className="submenu">
                                            <Link to="#" onClick={() => handleDropdownToggle('projectMeter')} 
                                                    className={activeDropdown === 'projectMeter' ? 'subdrop' : ''} style={{...a}}>
                                                <span> Project Meter</span> 
                                                <span className="menu-arrow" style={{...menuArrow}}></span>
                                            </Link> 
                                            <ul style={{...subDropDown, display: activeDropdown === 'projectMeter' ? 'block' : 'none' }}>
                                                <li><Link to="/project-meter" className={isActive('/project-meter')}>Active Project Meter</Link></li>
                                                <li><Link to="/inactive-project-meter" className={isActive('/inactive-project-meter')}>Inactive Project Meter</Link></li>
                                            </ul>
                                        </li>
                                    )}

                                    {(checkPermission("Assign Project")) && (
                                        <li className="submenu">
                                            <Link to="#" onClick={() => handleDropdownToggle('assignProject')} 
                                                    className={activeDropdown === 'assignProject' ? 'subdrop' : ''} style={{...a}}>
                                                <span> Assign Project</span> 
                                                <span className="menu-arrow" style={{...menuArrow}}></span>
                                            </Link> 
                                            <ul style={{...subDropDown, display: activeDropdown === 'assignProject' ? 'block' : 'none' }}>
                                                <li><Link to="/assign-project" className={isActive('/assign-project')}>Assign Project</Link></li>
                                            </ul>
                                        </li>
                                    )}
                                </ul>
                            </div>
                        )}

                        <div className="tab-pane fade" id="v-pills-employees" role="tabpanel"
                            aria-labelledby="v-pills-employees-tab">
                            <p>Employees</p>
                            <ul>
                                {(checkPermission("Employees")) && (
                                    <>
                                        <li><Link to="/employees" className={isActive('/employees')}>Active Employees</Link></li>
                                        <li><Link to="/inactive-employees" className={isActive('/inactive-employees')}>Inactive Employees</Link></li>
                                    </>
                                )}
                                <li><Link to="/leaves" className={isActive('/leaves')}>Leaves 
                                        {leavecount !== 0 ? <span className="badge rounded-pill bg-primary float-end">{leavecount}</span> : "" }
                                    </Link>
                                </li>
                            </ul>
                        </div>

                        <div className="tab-pane fade" id="v-pills-timelog" role="tabpanel" aria-labelledby="v-pills-timelog-tab">
                            <p>TimeLog</p>
                            <ul>
                                {user.role_name !== 'Super-Admin' && (
                                    <>
                                        <li><Link to="/assigned-projects" className={isActive('/assigned-projects')}> Assigned Projects </Link></li>
                                        <li><Link to="/timelog" className={isActive('/timelog')}> TimeLog </Link></li>
                                    </>
                                )}
                                {(checkPermission("Morning Time Logs")) && (
                                    <li><Link to="/timelog/manageTimeMorning" className={isActive('/timelog/manageTimeMorning')}>Time Morning</Link></li>
                                )}
                                {(checkPermission("Evening Time Logs")) && (
                                    <li><Link to="/timelog/manageTimeEvening" className={isActive('/timelog/manageTimeEvening')}> Time Evening</Link></li>
                                )}
                            </ul>
                        </div>

                        {(checkPermission("QA")) && (
                            <div className="tab-pane fade" id="v-pills-qa" role="tabpanel" aria-labelledby="v-pills-documentation-tab">
                                <p>QA</p>
                                <ul>
                                    <li><Link to="/qa" className={isActive('/qa')}> QA </Link></li>
                                </ul>
                            </div>
                        )}

                        {((checkPermission("Daily Reports")) || (checkPermission("Project Reports"))) && (
                            <div className="tab-pane fade" id="v-pills-daily-reports" role="tabpanel" aria-labelledby="v-pills-daily-reports-tab">
                                <p>Reports</p>
                                <ul>
                                    {(checkPermission("Daily Reports")) && (
                                        <>
                                            <li><Link to="/em-not-filled" className={isActive('/em-not-filled')}>EM Not Filled</Link></li>
                                            <li><Link to="/tl-approval-pending" className={isActive('/tl-approval-pending')}>TL Approval Pending</Link></li>
                                        </>
                                    )}
                                    {(checkPermission("Project Reports")) && (
                                        <>
                                            <li><Link to="/project-reports" className={isActive('/project-reports')}>Project Reports</Link></li>
                                            <li><Link to="/client-wise-reports" className={isActive('/client-wise-reports')}>Client-Wise Reports</Link></li>
                                        </>                                        
                                    )}
                                </ul>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TwoColumn